import React from 'react';

import { IdentityProvider } from '../../context';

import { NewFAProvider } from '.';

export function NewFuneralArrangementWrapper() {
  return (
    <IdentityProvider>
      <NewFAProvider />
    </IdentityProvider>
  );
}